<template>
  <mf-loading-dialog :loading="loadingDialog">
    <base-page-layout
      title="Resultados da campanha WhatsApp"
      hide-ecommerce-configuration
      use-new-filters
      :filters="['lojas']"
      :filter-to-units="campaignUnitIds"
    >
      <info-card
        :title="campaign.title"
        :description="campaign.description"
        :date="campaign.message && campaign.message.send_date"
        :time="campaign.message && campaign.message.send_time"
        :segments="campaign.segments"
        :products="campaign.products"
        :initial-date="campaign.initial_date"
        :final-date="campaign.final_date"
        :senders="campaign.senders || []"
        :targeting-mode="campaign.targeting_mode"
        :status="campaign.status"
        :canceled="campaign.message.cancelation.canceled"
        :canceled-at="campaign.message.cancelation.canceled_at"
        :canceled-by="canceledBy"
      />

      <v-row class="pt-3">
        <v-col class="pl-4">
          <span class="section-title">Resultados do disparo</span>
        </v-col>
      </v-row>

      <v-card v-if="!isExternalWhatsappProvider" class="mb-2">
        <v-card-text>
          <v-container fluid class="pa-0" grid-list-xl>
            <v-row class="px-3">
              <div>
                <span class="table-card-title-whats pl-0">Fila de disparo</span>
                <p class="subtitle">
                  Aqui você tem informações de como sua campanha está sendo entregue, por disparador. As informações são atualizadas de hora em hora.
                </p>
              </div>
              <v-spacer />
              <router-link class="link" :to="{ path: '/campanhas/whatsapp?tab=1' }"> Entender mais </router-link>
            </v-row>
          </v-container>
          <apexchart
            v-if="campaign && campaign.messages_queues"
            type="bar"
            height="250"
            :options="chartOptions"
            :series="series"
            @dataPointSelection="openHourDetails"
          ></apexchart>
          <v-row v-else justify="center" style="height: 265px">
            <v-col class="texto-corrido text-center" cols="4" style="padding-top: 100px"> Não existem dados a serem exibidos para essa campanha. </v-col>
          </v-row>
          <v-dialog v-if="details.length" v-model="dialog" class="variaveis-dialog" max-width="800px" scrollable>
            <v-card class="pa-2">
              <v-card-title class="pl-3" align-content-start>
                <div fluid class="pa-0" grid-list-xl>
                  <p class="title mb-0">{{ details[activeIndex].title }}</p>
                  <p class="subtitle">{{ campaign.title }}</p>
                </div>
                <v-spacer />
                <div>
                  <mf-tooltip bottom max-width="192px">
                    <template #activator="{ on }">
                      <mf-button
                        color="cinza-0"
                        size="sm"
                        icon="keyboard_arrow_left"
                        type="icon"
                        :disabled="activeIndex === 0"
                        @click="activeIndex = activeIndex - 1"
                      />
                    </template>
                    <span>Hora anterior</span>
                  </mf-tooltip>

                  <mf-tooltip bottom max-width="192px">
                    <template #activator="{ on }">
                      <mf-button
                        size="sm"
                        icon="keyboard_arrow_right"
                        type="icon"
                        color="cinza-0"
                        :disabled="activeIndex === categories.length - 1"
                        @click="activeIndex = activeIndex + 1"
                      />
                    </template>
                    <span>Próxima hora</span>
                  </mf-tooltip>
                </div>
              </v-card-title>
              <v-card-text ref="exampleMessage" class="py-3 px-0">
                <v-data-table :headers="headers" :items="details[activeIndex].senders" :items-per-page="5" :footer-props="{ itemsPerPageOptions: [5, 10, 15] }">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="nowrap-row">
                        <v-tooltip v-model="showTooltipTitle[item.name]" max-width="250" top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">{{ getFormatedText(item.name, 30) }}</span>
                          </template>
                          <span>{{ item.name }}</span>
                        </v-tooltip>
                      </td>
                      <td>{{ item.total }}</td>
                      <td>
                        {{ item.accumulated }} <span class="tax">{{ getTax(item.accumulated, item.total) }}%</span>
                      </td>
                      <td>{{ item.partial }}</td>
                    </tr>
                  </template>
                </v-data-table>
                <mf-action-buttons
                  class="mt-2"
                  :primary-button="{
                    text: 'Fechar',
                    action: () => (dialog = false),
                    isVisible: true,
                  }"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col cols="8" class="d-flex flex-column">
          <whatsapp-message-preview
            :file-url="campaign.message && campaign.message.attachment && campaign.message.attachment.data_url"
            :thumbnail-url="campaign.message && campaign.message.attachment && campaign.message.attachment.thumbnail_url"
            :file-name="campaign.message && campaign.message.attachment && campaign.message.attachment.filename"
            :file-mimetype="campaign.message && campaign.message.attachment && campaign.message.attachment.mimetype"
            :message="campaign.message"
          />
        </v-col>
        <v-col cols="4" class="d-flex flex-column">
          <v-row v-for="(card, index) in summaryCards" :key="`summary-card-${index}`">
            <v-col :class="[!index ? 'pt-0' : '', index === summaryCards.length - 1 ? 'pb-0' : '']">
              <cbm-card
                :number-text="card.value"
                :title="card.text"
                :is-currency="card.isCurrency"
                :percent-text="card.underText"
                :percent-description="card.description"
                :boolean-loader="loadingMetrics"
                :tooltip="card.helpText"
                unset-percentage-colors
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="pl-4 pt-3 pb-0">
          <span class="section-title">Resultados gerais</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <funnel base-metric="sent" :loading="loadingMetrics" :metrics="metrics" :campaign="campaign" :units-configuration="unitsConfiguration" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <products-table :loading="loadingMetrics" :metrics="metrics" :campaign="campaign" :units-configuration="unitsConfiguration" />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <sendings
            :show-delivery="false"
            :loading="loadingMetrics"
            :sendings="sendings"
            :campaign-id="getSafe(() => campaign._id)"
            :show-cost="false"
            campaign-type="whatsapp"
          />
        </v-col>
      </v-row>

      <mf-action-buttons
        :primary-button="{
          text: 'Fechar',
          action: () => $router.push('/campanhas/whatsapp'),
          isVisible: true,
        }"
        :cancel-button="{
          text: 'Cancelar disparo',
          action: cancel,
          isVisible: isAbleToCancelSendings,
          isDisabled: Boolean(campaignCancelSendingsDisabledTooltip),
          isLoading: loading,
          tooltip: Boolean(campaignCancelSendingsDisabledTooltip),
          tooltipMessage: campaignCancelSendingsDisabledTooltip,
        }"
      />
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import { QUERY_GET_CAMPAIGN_RESULTS_BY_ID } from '@/modules/campanhas/whatsapp/graphql'
import { QUERY_GET_CAMPAIGN_METRICS } from '@/modules/campanhas/views/components/graphql'
import { localeString } from '@/config/helpers.js'
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { MUTATION_CANCEL_CAMPAIGN } from '../../graphql'
import Swal from 'sweetalert2'
import truncate from 'lodash/truncate'
import capitalize from 'lodash/capitalize'
import { DateTime } from 'luxon'
import { mapState } from 'vuex'

export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    InfoCard: () => import('@/modules/campanhas/whatsapp/views/components/ResultadosInfoCard.vue'),
    WhatsappMessagePreview: () => import('@/modules/campanhas/whatsapp/views/pages/WhatsappMessagePreview.vue'),
    CbmCard: () => import('@/components/CbmCard.vue'),
    Funnel: () => import('@/modules/campanhas/views/components/results/Funnel.vue'),
    ProductsTable: () => import('@/modules/campanhas/views/components/results/ProductsTable.vue'),
    Sendings: () => import('@/modules/campanhas/views/components/results/Sendings.vue'),
  },
  data: () => ({
    campaignId: '',
    campaignUnitIds: [],
    campaign: {
      title: '',
      description: '',
      initial_date: '',
      final_date: '',
      products: [],
      segments: [],
      status: 'DRAFT',
      frequency: {
        type: 'ONETIME',
        interval: 0,
      },
      message: {
        text: '',
        send_date: '',
        send_time: '',
        cancelation: {
          canceled_at: '',
          canceled_by: {
            name: '',
          },
        },
      },
    },
    loadingDialog: false,
    loadingMetrics: false,
    metrics: {},

    showTooltipTitle: {},
    dialog: false,
    showTooltip: false,
    sendings: [],
    locale: localeString,
    loading: false,
    details: [],
    activeIndex: 0,
    categories: [],
    series: [],
    DateTime: DateTime,
    chartOptions: {
      chart: {
        type: 'bar',
        height: 250,
        stacked: true,
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: false,
        },
        events: {
          dataPointMouseEnter: function (event) {
            event.path[0].style.cursor = 'pointer'
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 3,
          horizontal: false,
          columnWidth: '17px',
          dataLabels: {
            position: 'top',
            hideOverflowingLabels: false,
          },
        },
      },
      // colors: ['#0818A8', '#40B5AD', '#0437F2', '#40E0D0', '#008080', '#0F52BA', '#87CEEB'],
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#304758'],
        },
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          if (seriesIndex === w.config.series.length - parseInt(1)) {
            return w.globals.stackedSeriesTotals[dataPointIndex]
          }
          return ''
        },
      },
      states: {
        hover: {
          filter: {
            type: 'none',
          },
        },
        active: {
          filter: {
            type: 'none',
          },
        },
      },
      tooltip: {
        custom: function () {
          return '<div><span class="apex-tooltip">Clique para ver mais detalhes</span></div>'
        },
      },
      legend: {
        show: true,
        position: 'right',
        fontFamily: 'Lato',
        markers: {
          radius: '6px',
          width: '10px',
          height: '10px',
        },
        showForSingleSeries: true,
        onItemClick: {
          toggleDataSeries: false,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
      },
      fill: {
        opacity: 1,
      },
    },
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
    isAbleToCancelSendings() {
      return ['ACTIVE'].includes(this.campaign.status) && !this.isExternalWhatsappProvider
    },
    isExternalWhatsappProvider() {
      return this.$getAllowedModules()['external_whatsapp_provider']
    },
    unitsConfiguration() {
      return this.stateFilters.unitsConfiguration
    },
    headers() {
      return [
        {
          text: 'Disparador',
          value: 'name',
          width: '10%',
        },
        {
          text: 'Total de disparos',
          value: 'total',
          width: '10%',
        },
        {
          text: 'Total acumulado',
          value: 'accumulated',
          width: '10%',
        },
        {
          text: 'Nesta hora',
          value: 'partial',
          width: '10%',
        },
      ]
    },
    canceledBy() {
      return this.campaign.message.cancelation?.canceled_by?.name
    },
    summaryCards() {
      return [
        {
          value: localeString(this.metrics?.general_metrics?.general?.messages_received || 0),
          text: 'Mensagens enviadas',
          helpText:
            'Devido as características de integração com a Meta, não existe a possibilidade de medir com assertividade a taxa de entrega das mensagens.',
        },
        {
          value: localeString(this.metrics?.clients_metrics?.received_and_bought?.count || 0),
          text: 'Clientes que compraram',
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.clients_metrics?.received_and_bought?.count / this.metrics?.clients_metrics?.received?.count) * 100 || 0,
            1
          )}%`,
          description: `dos ${this.locale(this.metrics?.clients_metrics?.received?.count || 0)} clientes participantes da campanha`,
          helpText: 'Quantidade de clientes participantes da campanha que realizaram pelo menos uma compra no período de mensuração',
        },
        {
          value: this.locale(this.metrics?.clients_metrics?.received_and_bought?.average_ticket || 0, 2),
          text: 'Ticket médio',
          underText: `${this.locale(this.metrics?.analytic_metrics?.average_ticket_received_variation, 1)}%`,
          description: `a ${this.metrics?.analytic_metrics?.average_ticket_received_variation > 0 ? 'mais' : 'menos'} do que quem não participou da campanha`,
          helpText:
            'Ticket médio dos clientes participantes da campanha que realizaram pelo menos uma compra no período de mensuração em comparação com o ticket médio dos consumidores do clube no mesmo período dessa campanha',
          isCurrency: true,
        },
        {
          value: localeString(this.metrics?.clients_metrics?.received_and_bought?.revenue || 0, 0),
          text: 'Faturamento',
          underText: `${this.locale(
            this.getSafe(() => this.metrics?.clients_metrics?.received_and_bought?.revenue / this.metrics?.clients_metrics?.total?.revenue) * 100 || 0,
            1
          )}%`,
          description: `do faturamento total`,
          helpText:
            'Faturamento dos clientes participantes da campanha que realizaram pelo menos uma compra no período de mensuração em comparação com o faturamento dos consumidores do clube no mesmo período dessa campanha',
          isCurrency: true,
        },
      ]
    },
    messagesQueues() {
      return this.campaign.messages_queues
    },
    units() {
      return this.stateFilters.units
    },
    campaignCancelSendingsDisabledTooltip() {
      const now = DateTime.now().toFormat('yyyy-MM-dd')
      if (this.campaign.message?.send_date !== now) return this.$t('campanhas.tooltips.cancel_sendings.out_of_date')
      if (this.campaign.message?.cancelation?.canceled) return this.$t('campanhas.tooltips.cancel_sendings.already_canceled')
      return ''
    },
  },
  watch: {
    $route(route) {
      if (route.params?.id?.length !== 24 && route.query?.quick_action) {
        // Reset the data
        Object.assign(this.$data, this.$options.data.apply(this))
      }
    },
  },
  async mounted() {
    this.campaignId = this.$route.params.id
    if (this.campaignId?.length !== 24) this.campaignId = ''
    await this.fetchData()
    if (this.campaign.messages_queues) this.formatData()

    this.$nextTick(() => {
      this.$bus.$on('filter', this.getCampaignMetrics)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    async fetchData() {
      try {
        this.loadingDialog = true
        await this.getCampaign()
        await this.getCampaignMetrics()
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingDialog = false
      }
    },
    async getCampaign() {
      const {
        data: { campaign },
      } = await this.$apollo.query({
        query: QUERY_GET_CAMPAIGN_RESULTS_BY_ID,
        notifyOnNetworkStatusChange: true,
        context: {
          uri: this.$microservicesUrls['campaigns'],
        },
        variables: {
          id: this.campaignId,
        },
        fetchPolicy: 'no-cache',
      })
      this.campaign = campaign
      if (campaign.units?.length) this.campaignUnitIds = campaign.units.map((unit) => unit.id_erp)
    },
    async getCampaignMetrics() {
      try {
        this.loadingMetrics = true
        const {
          data: { campaign },
        } = await this.$apollo.query({
          query: QUERY_GET_CAMPAIGN_METRICS,
          notifyOnNetworkStatusChange: true,
          variables: {
            id: this.campaignId,
            units: this.units,
          },
          context: {
            uri: this.$microservicesUrls['campaigns'],
          },
          fetchPolicy: 'no-cache',
        })
        if (!campaign) return
        this.sendings = campaign?.message?.sendings || []
        this.metrics = campaign.metrics
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingMetrics = false
      }
    },
    getTax(acc, total) {
      if (acc / total) return Math.round((acc / total) * 100)
      else return 0
    },
    async cancel() {
      this.$confirm({
        title: 'Cancelar disparos',
        message:
          'Todos os disparos ainda não realizados serão cancelados, e <span class="texto-corrido-destaque">não poderão ser reiniciados</span>. O status da campanha continuará ativo e captando resultados dos disparos realizados até o fim da data de mensuração.',
        confirmText: 'Cancelar',
        cancelText: 'Voltar',
      })
        .then(async () => {
          this.loading = true
          try {
            await this.$apollo.mutate({
              mutation: MUTATION_CANCEL_CAMPAIGN,
              variables: {
                id: this.campaign._id,
              },
              context: {
                uri: this.$microservicesUrls['campaigns'],
              },
            })

            Swal.fire({
              text: 'Disparos cancelados',
              icon: 'success',
              showConfirmButton: false,
              timer: 1000,
              customClass: {
                content: 'content-class',
              },
            })

            await this.fetchData()
            window.scrollTo(0, 0)
          } catch (error) {
            console.log(error)
            this.$snackbar({ message: 'Erro ao cancelar disparos.', snackbarColor: 'error' })
          } finally {
            this.loading = false
          }
        })
        .catch(() => {})
    },
    getFormatedText(text, length) {
      return truncate(text, {
        length: length,
        separator: ' ',
      })
    },
    formatNumber(number) {
      return phoneNumberFormat(number)
    },
    openHourDetails(event, chartContext, config) {
      this.activeIndex = config.dataPointIndex
      this.dialog = true
    },
    formatData() {
      var dayLabel = ''
      let senders = []
      let time = []
      let sendersNames = []
      let messageQueues = {}
      this.messagesQueues.forEach((obj) => {
        this.categories.push(obj.time)
        time.push(DateTime.fromFormat(obj.time, 'yyyy-MM-dd HH:mm').toFormat('HH:mm'))

        obj.queues.forEach((k) => {
          let phone = this.formatNumber(k.sender.number)
          let name = k.sender.name ? this.getFormatedText(`${k.sender.name} - ${phone}`, 42) : phone
          sendersNames.push(k.sender.name ? `${k.sender.name} - ${phone}` : phone)
          messageQueues[name] = messageQueues[name] || []
          messageQueues[name].push(k.quantity)
        })
      })
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            categories: time,
          },
        },
      }
      for (let [key, value] of Object.entries(messageQueues)) {
        this.series.push({
          name: key,
          data: value,
        })
      }

      for (var index in this.categories) {
        dayLabel = capitalize(
          DateTime.fromFormat(this.categories[index], 'yyyy-MM-dd HH:mm').setLocale('pt-BR').toFormat("'Dia' dd 'de' MMMM 'de' yyyy - HH'h'")
        )
        senders.push(
          this.series.map((item, pos) => {
            let max =
              DateTime.fromFormat(time[index], 'HH:mm').toFormat('HH') >= DateTime.fromFormat(this.campaign.message.send_time, 'HH:mm').toFormat('HH')
                ? Math.max(...item.data)
                : 0
            let diff = item.data[index - 1] ? item.data[index - 1] - item.data[index] : 0
            return {
              name: sendersNames[pos],
              partial: diff,
              total: max,
            }
          })
        )

        this.details.push({
          title: dayLabel,
          senders: senders[index],
        })
      }

      for (let [key, value] of Object.entries(this.details)) {
        value.senders.map((item, index) => {
          item.accumulated =
            key > 0
              ? this.details[parseInt(key) - 1].senders[index].accumulated + this.details[key].senders[index].partial
              : this.details[key].senders[index].partial
          return item
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.table-card-title-whats {
  font-size: 18px;
  color: $cinza-d10;
  @extend .card-title;
}
.subtitle {
  display: block;
}
.apexcharts-legend {
  white-space: nowrap;
  max-width: 25%;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.apex-tooltip {
  background: rgba(97, 97, 97, 0.9);
  color: $branco;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  padding: 5px 16px;
  text-transform: none;
  width: auto;
  opacity: 1;
  pointer-events: none;
}
.tax {
  color: $cinza-l20;
}
</style>
